<script>
export default {
	props: {
		validation: {
			type: Object,
		},
		keysPrefix: {
			type: String,
		},
		keysFilter: {
			type: Function,
		},
		inputsKeysFilter: {
			type: Function,
		},
	},
	data() {
		return {
			comps: {},
			uncatched: {},
			ids: 0,
		}
	},
	provide() {
		return {
			registerValidatorComponent: (comp) => {
				if (typeof comp.setValidation == 'function' && typeof comp.getValidatorKey == 'function') {
					let id = (this.ids += 1)
					if (!comp.focus) {
						comp.focus = () => {
							comp.$el.setAttribute('tabindex', '-1')
							comp.$el.focus()
						}
					}
					this.comps[`comp_${id}`] = comp
					return id
				} else {
					return null
				}
			},
			unregisterValidatorComponent: (id) => {
				delete this.comps[`comp_${id}`]
			},
			getParentValidation: () => this.validation,
		}
	},
	watch: {
		validation: {
			handler(value) {
				let validation = {}
				if (value) {
					for (let [key, msg] of Object.entries(value)) {
						if (Array.isArray(msg)) msg = msg.join(' | ')
						if (this.keysFilter) key = this.keysFilter(key)
						if (this.keysPrefix) key = `${this.keysPrefix}.${key}`
						validation[key] = msg
					}
				}
				this.validate(validation)
			},
			deep: true,
		},
	},
	methods: {
		validate(validation) {
			let firstError = false
			let foundKeys = []
			for (let comp of Object.values(this.comps)) {
				let key = comp.getValidatorKey()
				if (!key) continue
				if (this.inputsKeysFilter) key = this.inputsKeysFilter(key)
				let error = validation[key]
				if (error) foundKeys.push(key)
				comp.setValidation(error)
				if (!firstError && error) {
					firstError = true
					comp.focus()
					this.$emit('input-focused', comp)
				}
			}
			let uncatched = {}
			Object.keys(validation)
				.filter((k) => !foundKeys.includes(k))
				.forEach((k) => (uncatched[k] = this.validation[k]))
			this.uncatched = uncatched
		},
	},
	render() {
		if (typeof this.$scopedSlots.default == 'function') {
			return this.$scopedSlots.default(this.uncatched || {})
		} else {
			return this.$slots.default
		}
	},
}
</script>
